/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

import { MessageLibraryItemStatus } from 'cio/models/message-library-item';

const STATE_TO_TAG_MAP: Record<MessageLibraryItemStatus, string> = {
  [MessageLibraryItemStatus.Active]: 'is-success',
  [MessageLibraryItemStatus.Automatic]: 'is-success',
  [MessageLibraryItemStatus.Draft]: 'is-warning',
  [MessageLibraryItemStatus.Drafted]: 'is-pending',
  [MessageLibraryItemStatus.Off]: 'is-danger',
  [MessageLibraryItemStatus.Sent]: 'is-success',
  [MessageLibraryItemStatus.Empty]: '',
};

interface MessageLibraryItemStatusTagArgs {
  status: MessageLibraryItemStatus;
}

export default class MessageLibraryItemStatusTag extends Component<MessageLibraryItemStatusTagArgs> {
  get statusClass() {
    return STATE_TO_TAG_MAP[this.args.status];
  }
}
